<template>
  <v-container fluid ma-0 pa-0>
    <!-- DIALOG AGENCIES -->
    <v-dialog
      v-model="showAgencies"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-flex class="text-xs-center" px-2 pt-3 pb-2>
          <h2>Seleccionar Agencia</h2>
        </v-flex>
        <agencies-tree :from-section="fromSection" />
        <v-flex d-flex pa-3 mx-2>
          <v-spacer></v-spacer>
          <v-btn 
            color="error" 
            @click="showAgencies = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="showAgencies = false"
            :disabled="agencySelected === null"
          >
            Aceptar
          </v-btn>
        </v-flex>
      </v-card>
    </v-dialog>
    <!-- CONTENT -->
    <v-flex class="section-1 general-bg" ma-0 pt-4 px-4>
      <h3 class="text-xs-left pt-2">Último evento recibido</h3>
      <h4 class="text-xs-left pt-2">Reporte por Grupo/Agencia</h4>
      <!-- SELECT AGENCIE -->
      <v-flex my-2 py-3>
        <v-flex class="caption" pl-2>*Opcional</v-flex>
        <h5 class="pl-2">Seleccionar Agencia</h5>
        <v-btn
          color="primary"
          block
          :loading="$loading.isLoading('fetchingAgenciesTree')"
          @click="showAgencies = true"
        >
          <v-icon left>business</v-icon>
          Agencias
        </v-btn>
        <!-- AGENCY SELECTED -->
        <v-flex v-if="agencySelected && !$loading.isLoading('fetchingAgenciesTree')" pl-2>
          <h6>Agenica Seleccionada</h6>
          <h5>{{ agencySelected.name }}</h5>
        </v-flex>
      </v-flex>
      <v-divider></v-divider>
      <!-- BUTTON -->
      <v-flex class="text-xs-center" py-3>
          <!-- :href="urlReportPoint" -->
        <v-btn
          v-if="!reportReadyGLER"
          color="primary"
          block
          :loading="$loading.isLoading('fetchLastEventReport')"
          @click="getLastEventReportIn"
        >
          <v-icon left>description</v-icon>
          Generar Reporte
        </v-btn>
        <v-btn
          v-if="reportReadyGLER"
          :href="urlReportGLER"
          target="_blank"
          color="success"
          block
          @click="toggleBtnGLER(false)"
        >
          <v-icon left>cloud_download</v-icon>
          Descargar Reporte
        </v-btn>
      </v-flex>
    </v-flex>
  </v-container>
</template>

<script>
import AgenciesTree from '../AgenciesTree'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'report-last-event-vehicle',
  components: {
    AgenciesTree
  },
  data() {
    return {
      fromSection: 'reports',
      showAgencies: false
    }
  },
  computed: {
    ...mapGetters(['agencySelected', 'reportReadyGLER', 'urlReportGLER'])
  },
  methods: {
    ...mapActions(['toggleBtnGLER', 'getLastEventReport']),
    getLastEventReportIn() {
      // console.log(this.agencySelected)
      const payload = {
        agencyId: this.agencySelected ? this.agencySelected.agencyId : null
      }
      this.getLastEventReport(payload)
    }
  }
}
</script>

<style lang="stylus" scoped>
h3
  font-size 30px
  font-weight 500
  line-height 7px

h4
  font-size 21px
  font-weight 500

h5
  font-size 16px
  font-weight 500

h6
  font-size 14px
  font-weight 400

.section-1
  min-width 390px
  max-width 390px
  
.general-bg
  background-color #424242
  border-radius 3px

</style>



// WEBPACK FOOTER //
// src/components/Reports/ReportLastEventVehicle.vue